// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Zl4tj6cB6WZUbDQ0tYR9 {
  animation: TA8Dg9xAZrGTFeqYfy7r 2s linear infinite;
}
.Zl4tj6cB6WZUbDQ0tYR9 > circle {
  stroke: var(--dry-primary);
  stroke-linecap: round;
  animation: td4fStxLvB2SAvwiY6LL 1.5s ease-in-out infinite;
}
@keyframes TA8Dg9xAZrGTFeqYfy7r {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes td4fStxLvB2SAvwiY6LL {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Zl4tj6cB6WZUbDQ0tYR9`,
	"rotate": `TA8Dg9xAZrGTFeqYfy7r`,
	"dash": `td4fStxLvB2SAvwiY6LL`
};
export default ___CSS_LOADER_EXPORT___;
